import TanStackTable from "root/TanstackTables/TanStackTable";
import React from "react";
import IconTooltip from "ui/Tooltip/IconTooltip";
import {ModalFutureAbsenceModes} from "root/s360components/Modals/FutureAbsence/useModalFutureAbsence";
import TableNoDataComponent from "root/s360components/Tables/TableNoData/TableNoDataComponent";

const FutureAbsenceTable = ({data, onClickAction}) =>
{

    const actionFormatter = (info) =>
    {
        const row = info.row.original;

        return <div style={{alignItems: "center", textAlign: "center", display: "flex", justifyContent: "space-evenly"}}>
            <IconTooltip icon='glyphicon-edit' color='#337ab7' placement='top' text="Edit" onClick={() => onClickAction(ModalFutureAbsenceModes.EDIT, row.long_term_absence_id)}/>
            <IconTooltip icon='glyphicon-trash' color='#e15554' placement='top' text="Delete"  onClick={() => onClickAction(ModalFutureAbsenceModes.DELETE, row.long_term_absence_id)}/>
        </div>
    }


    const columns = [
        {accessorKey: 'absence_from_date', header: 'Absent From', enableSorting: true},
        {accessorKey: 'absence_to_date', header: 'Absent To', enableSorting: true},
        {accessorKey: 'forename', header: 'Forename', enableSorting: true},
        {accessorKey: 'surname', header: 'Surname', enableSorting: true},
        {accessorKey: 'absence_code', header: 'Reason (code)', enableSorting: true},
        {accessorKey: 'notes', header: 'Notes', enableSorting: true},
        {accessorKey: 'actions', header: 'Actions', enableSorting: true, meta: {textAlign: 'center'}, cell: actionFormatter},
    ];

    return (
        <div className='future-absence-table' key='userTable'>
            <TanStackTable data={data} columns={columns} showSearch={true}/>
            {data.length === 0 && <TableNoDataComponent/>}
        </div>
    )
}

export default FutureAbsenceTable;